import { render, staticRenderFns } from "./TextModuleDetail.vue?vue&type=template&id=5028cdee"
import script from "./TextModuleDetail.vue?vue&type=script&lang=js"
export * from "./TextModuleDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports